import {billableItemSvg as Icon__small__billableItemSvg} from '../Icon__small/Icon__small--billableItem.js';
import {billableItemSvg as Icon__xsmall__billableItemSvg} from '../Icon__xsmall/Icon__xsmall--billableItem.js';

export var billableItem = {
  name: 'billableItem',
  category: 'icon',
  colorable: true,
  svg: Icon__small__billableItemSvg,
  alt: {
    Icon__small: Icon__small__billableItemSvg,
    Icon__xsmall: Icon__xsmall__billableItemSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
